import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { PushButton } from '../../components';
import { toNumber } from '../../../../utils/numbers';
import convertUnit from '../../../../utils/unit-converter';
import DecumScale from './DecumScale';
import {
  TargetLabel,
  BalanceLabel,
  FlowRateLabel,
  FlowRateTargetLabel,
} from '../../components/labels';
import cx from 'classnames';
import { DeviceStatus } from '../../../../constants/DeviceStatus';

@observer
class Decum extends Component {

  render() {
    const { device, batchStore, materialStore } = this.props;
    let materials = materialStore.materials.filter(v => v.scaleId === device.id && v.visible);
    materials = materials.sort((a, b) => a.position - b.position);
    const md = materials.length ? materialStore.materialDetails[materials[0].materialDetailId] || {} : {};
    const materialType = (md.type)?.toLowerCase();
    const deviceStatus = batchStore.getDeviceStatus(device.id);
    const { unit, uid, tId, truckCode, currentDrop, allDrops, flowRate, totalFinalTarget = 0, currentFlowRate } = deviceStatus;
    const mCode = uid ? `${truckCode || tId || uid} ${currentDrop}/${allDrops}` : '.';
    const weight = batchStore.getScaleWeight(device);
    const indicatorError = batchStore.isIndicatorValueError(weight) ? DeviceStatus.INDICATOR_ERROR : '';
    const deviceUnit = batchStore.getUnitById(device.unitId);
    const batchUnit = unit || deviceUnit;
    const isDeferenceUnit = unit && totalFinalTarget ? unit !== deviceUnit : false;
    const fTarget = toNumber(totalFinalTarget, 0);
    let convertedWeight = 0;
    let convertedFinishTarget = 0;

    if (isDeferenceUnit) {
      convertedWeight = toNumber(convertUnit(weight, deviceUnit, batchUnit), 0);
      convertedFinishTarget = toNumber(convertUnit(fTarget, deviceUnit, batchUnit), 0);
    }

    return (
      <div className={`device-gui decum-multi-scale materials-size-${materials.length}`}>

        <div
          className={cx(
            `decum-scales materials-size-${materials.length}`,
            materialType ? `material-${materialType}`:'',
          )}
        >
          {materials.length
            ?
            materials.map((material) => (
              <DecumScale key={material.itemId} {...this.props} material={material} />
            ))
            : <DecumScale {...this.props}/>
          }
        </div>

        {device.inputPNo && (
          <button className="btn-batch btn-batch-red btn-reset-indicator"
            title="Reset weight"
            onClick={() => batchStore.resetIndicator(device.inputPNo)}>
            <i className="fa fa-refresh"/>
          </button>
        )}

        <div className="device-label-group">

          <div className="device-label device-label-target decum-top-target">
            <TargetLabel target={fTarget} unit={deviceUnit} convertedTarget={convertedFinishTarget} convertedUnit={batchUnit}/>
            <BalanceLabel balance={indicatorError || weight} unit={deviceUnit} convertedBalance={convertedWeight} convertedUnit={batchUnit}/>
            <div className="mix" title={mCode}>{mCode}</div>
          </div>

          {(!device.parentScaleId && !device.noFlowControl) && (
            <div className="device-label device-label--flow">
              <FlowRateTargetLabel target={flowRate} unit={deviceUnit}/>
              <FlowRateLabel flowrate={currentFlowRate} unit={deviceUnit}/>
              <div className="flow-rate-buttons">
                <PushButton
                  className="btn-batch btn-batch-red"
                  onPush={() => batchStore.onFlowRateDown(device)}
                >
                  <i className="fa fa-minus"/>
                </PushButton>
                <PushButton
                  className="btn-batch btn-batch-green"
                  onPush={() => batchStore.onFlowRateUp(device)}
                >
                  <i className="fa fa-plus"/>
                </PushButton>
              </div>
            </div>
          )}
        </div>

      </div>
    );
  }
}

export default Decum;
